<div class="counts" *ngIf="counts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title">
        Pending Production Manager Approval
        <span>{{ counts.total }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div class="panel-item"
           [routerLink]="['counts/list', 'pendingProductionManagerApprovalCounts', 'pendingPMApproval']">
        <p class="count">Contracts Pending Approval</p>
        <span>{{ counts.pendingPMApproval }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
